<template>
  <div class="Seguro-Colectivo-Salud">
    <Header />
    <div class="title">
      <h1>Aliados - Aseguradoras</h1>
      <div id="contactForm">
        <label for="">Conoce más sobre soluciones de seguros</label>
        <div id="hubcontactForm"></div>
      </div>
    </div>
    <div class="info top">
                <h1>¿Necesitas entrar en contacto con tu aseguradora?</h1>
                <p>Encuentra sus líneas de asistencia y atención al cliente en nuestro directorio de aseguradoras.
                </p>
        </div>
    <div class="table">
        <center>
            <table :class="{'vissible': !display}">
                <tbody>
                    <tr class="header">
                        <th>
                            Compañía
                        </th>
                        <th>
                            Línea de Atención Bogotá
                        </th>
                        <th>
                            Línea de Atención Nacional
                        </th>
                        <th>
                            Desde tu Celular
                        </th>
                        <th>
                            Link para Pagos
                        </th>
                    </tr>
                    <tr v-for="(aliado, i) in aliados" :key="i" :style="{'background-color': aliado.type_color}" class="body">
                        <td>
                            <img :src="aliado.imagen" alt="">
                        </td>
                        <td v-html="aliado.bogota">
                        </td>
                        <td v-html="aliado.nacional">
                        </td>
                        <td v-html="aliado.celular">
                        </td>
                        <td>
                            <a :href="aliado.pagos">
                                <div>
                                    <p>Pagos</p>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100">
                                            <path class="elementor-shape-fill" d="M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"></path>
                                        </svg>
                                    </div>
                                </div>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="list" :class="{'vissible': display}">
                <div v-for="(aliado, i) in aliados" :key="i" :style="{'background-color': aliado.type_color}">
                    <div><img :src="aliado.imagen" alt=""></div>
                    <label for="">Línea de Atención Bogotá:</label>
                    <p v-html="aliado.bogota"></p>
                    <label for="">Línea de Atención Nacional:</label>
                    <p v-html="aliado.nacional"></p>
                    <label for="">Desde tu Celular:</label>
                    <p v-html="aliado.celular"></p>
                    <label for="">Link para Pagos:</label>
                    <div class="button">
                        <p>Pagos</p>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100">
                                <path class="elementor-shape-fill" d="M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"></path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </center>
        <div class="cubrimos">
            <div class="service" v-for="(service, i) in services" :key="i">
                <h1>Si necesitas contactarnos puedes hacerlo a través de nuestros canales de atención.</h1>
                <div v-if="service.type">
                    <div class="imgbox">
                        <img :src="service.img" alt="">
                    </div>
                    <div class="box">
                        <img src="@/assets/icon-place.svg" alt="">
                        <label for="">Nuestra Ubicación, Sede Principal</label>
                        <p>Carrera 13 # 90-17, Bogotá, Colombia</p>
                        <img src="@/assets/icon-horario.svg" alt="">
                        <label for="">Horario de Atención</label>
                        <p>Lunes a viernes de 08:00 a.m. - 06:00 p.m y sábados de 08:00 a.m. - 12:00m.</p>
                        <img src="@/assets/icon-phone.svg" alt="">
                        <label for="">Teléfono</label>
                        <p>Línea Corporativa: 6017171621 - Línea PBX: 6016381064</p>
                        <img src="@/assets/icon-whatsapp.svg" alt="">
                        <label for="">Móvil y WhatsApp</label>
                        <p>314 7375012 / 300 4543623</p>
                        <img src="@/assets/icon-mail.svg" alt="">
                        <label for="">Mail</label>
                        <p>informacion@grupogeos.co</p>
                        <button @click="goTop()">Ponte en contacto con nosotros</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from './Header/Header'
import Footer from './Footer/Footer'

export default {
    name: 'Seguro-Colectivo-salud',
    components: {
        Header,
        Footer
    },
    metaInfo() {
        return {
            title: 'Nuestros aliados',
            titleTemplate: '%s | Interseguros',
            meta: [{
                vmid: 'description',
                name: 'description',
                content: 'Consulta nuestro directorio de aseguradoras de Colombia para conocer los números de asistencias y atención de cada una fácilmente.'
            },
            {
                vmid: 'keywords',
                name: 'keywords',
                content: 'Asesor en riesgos laborales, intermediación ARL, Control de ARL, Seguros ARL, Administradora de Riesgo Laborales, Seguros Generales, Seguros Empresariales, Seguros Personales'
            },
            {
                vmid: 'image',
                name: 'image',
                content: require('@/assets/logo/logo.webp')
            },
            {
                vmid: 'robots',
                name: 'robots',
                content: 'index, follow'
            },
            {
                vmid: 'twitter:card',
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                vmid: 'twitter:title',
                name: 'twitter:title',
                content: 'Interseguros'
            },
            {
                vmid: 'twitter:site',
                name: 'twitter:site',
                content: '@Interseguros'
            },
            {
                vmid: 'twitter:description',
                name: 'twitter:description',
                content: 'Consulta nuestro directorio de aseguradoras de Colombia para conocer los números de asistencias y atención de cada una fácilmente.'
            },
            {
                vmid: 'twitter:image',
                name: 'twitter:image',
                content: require('@/assets/image-people.png')
            }]
        }
    },
    data() {
        return {
            display: null,
            services: [
                {
                    type: true,
                    img: require('@/assets/contactenos.png'),
                    label: 'Nuestro próposito'
                }
            ],
            aliados: [
                {
                    imagen: require('@/assets/aliados/seguros-aseguradora-solidaria.png'),
                    bogota: '(+57 1) 291 68 68',
                    nacional: '01 8000 512021',
                    celular: '# 789',
                    pagos: 'https://aseguradorasolidaria.com.co/no-encontrada.aspx?page=servicios-en-linea/multipago.aspx',
                    type_color: '#fff'
                },
                {
                    imagen: require('@/assets/aliados/seguros-axa-colpatria.png'),
                    bogota: '(+57 1) 423 57 57 (Seguros <br> y ARL) <br> (+57 1) 423 57 50 <br> (Exclusivo salud)',
                    nacional: '01 8000 512620 <br> (Seguros y ARL) <br> 01 8000 515750 <br> (Exclusivo salud)',
                    celular: '# 247',
                    pagos: 'https://www.axacolpatria.co/pagosenlinea/opcionespago',
                    type_color: '#fff'
                },
                {
                    imagen: require('@/assets/aliados/seguros-colmena.png'),
                    bogota: '(+57 1) 401 04 47',
                    nacional: ' Medellín: <br> (+57 4) 444 12 46 <br> Cali: (+57 2) 403 64 00 <br> Otras ciudades: <br> 01 8000 919667',
                    celular: '',
                    pagos: 'https://www.colmenaseguros.com/seguros-personas/Paginas/pago-de-polizas-empresas.aspx',
                    type_color: '#fff'
                },
                {
                    imagen: require('@/assets/aliados/seguros-bsb.png'),
                    bogota: '(+57 1) 313 87 00',
                    nacional: '01 8000 911360',
                    celular: '# 360',
                    pagos: 'https://sbseguros.co/zonapagos/',
                    type_color: '#fff'
                },
                {
                    imagen: require('@/assets/aliados/seguros-bolivar.png'),
                    bogota: '',
                    nacional: '01 8000 123322',
                    celular: '# 322',
                    pagos: 'https://www.segurosbolivar.com/RecaudosElectronicos/faces/muestrapagos.jspx/pages/layout/consultUser.action',
                    type_color: '#fff'
                },
                {
                    imagen: require('@/assets/aliados/seguros-del-estado.png'),
                    bogota: '(+57 1) 307 82 88',
                    nacional: '01 8000 123010',
                    celular: '# 688',
                    pagos: 'https://www.portalestado.transfiriendo.com/PortalPaguestado/Webforms/Account/Views/Index.aspx',
                    type_color: '#fff'
                },
                {
                    imagen: require('@/assets/aliados/seguros-sura.png'),
                    bogota: '(+57 1) 437 88 88',
                    nacional: 'Medellin y Cali: <br> 437 8888 <br> Otras ciudades: 01 8000 <br> 518888',
                    celular: '# 888',
                    pagos: 'https://www.segurossura.com.co/paginas/pago-express.aspx#/Pagos',
                    type_color: '#fff'
                },
                {
                    imagen: require('@/assets/aliados/seguros-zurich.png'),
                    bogota: 'Copropiedades y Pymes: <br> (+57 1) 5114559',
                    nacional: '01 8000 112 723 <br> Copropiedades y Pymes: <br> 01 8000 944559 WhatsApp: <br> 3173643185',
                    celular: '# 723',
                    pagos: 'https://www.zurichseguros.com.co/es-co/formas-de-pago',
                    type_color: '#fff'
                }
            ]
        }
    },
    created() {
        window.addEventListener('resize', this.myEventHandler)
    },
    destroyed() {
        window.removeEventListener('resize', this.myEventHandler)
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
        if (window.innerWidth > 990) {
            this.display = true
        } else {
            this.display = false
        }
    },
    methods: {
        myEventHandler(e) {
            if (window.innerWidth > 990) {
                this.display = true
            } else {
                this.display = false
            }
        },
        goTop() {
            if (window.scrollY > 0) {
                var newScroll = window.scrollY - 10
                setTimeout(() => {
                    window.scrollTo(0, newScroll)
                    this.goTop()
                }, 1)
            }
        }
    }
}
</script>

<style scoped>

.info {
    padding: 100px 0px;
}
.info > h1 {
    width: 60%;
    font-family: 'JBD';
    color: #65b24a;
    padding-left: 200px;
    font-size: 40px;
}
.info > p {
    font-family: 'JR';
    width: 60%;
    padding-left: 200px;
    margin-top: 10px;
    font-size: 18px;
}
.list > div > .button {
    background-color: #65b24a;
    position: relative;
    transform: scale(0.5);
    border-radius: 0.3rem;
    padding: 0.475rem 0.85rem;
    max-width: 100%;
    height: 80px;
    color: #fff;
    transition: all .2s ease-out;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
}
.list > div > .button > p{
    font-size: 30px;
    font-family: 'JR';
    color: inherit;
}

.list > div > .button > div{
    order: -1;
    width: 45px;
    height: 45px;
    margin-top: -35px;
}
.list {
    padding: 10px 10%;
}
.list > div {
    display: block;
    padding: 100px 10%;
}
.table {
    margin-top: 0px;
    width: 100%;
    padding: 50px 200px;
}
.table > center > table {
    border-width: 0px;
    border-style: solid;
    border-image: initial;
    min-width: 100%;
    width: 100%;
}
.table > center > table > tbody > .header {
    margin: 0;
    padding: 0;
    border: 0;
    font-weight: inherit;
    font-style: inherit;
    font-size: 100%;
    font-family: inherit;
    vertical-align: baseline;
    background-color: #2d4f98;
}
.table > center > table > tbody > .header > th {
    padding: 15px;
    font-family: 'JBD';
    border: 1px solid #ddd;
    text-align: center;
    height: 50px;
    color: #fff;
}

.table > center > table > tbody > .body > td {
    padding: 0.475rem 0.85rem;
    margin-top:10px;
    text-align: center;
    font-family: 'JR';
    border: 1px solid #ddd;
    height: 50px;
    text-align: center;
    position: relative;
    color: #7E8090;
}

.table > center > table > tbody > .body > td > a {
    text-decoration: none!important;
}

.table > center > table > tbody > .body > td > a > div {
    background-color: #65b24a;
    position: relative;
    transform: scale(0.5);
    border-radius: 0.3rem;
    padding: 0.475rem 0.85rem;
    max-width: 100%;
    height: 80px;
    color: #fff;
    transition: all .2s ease-out;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
}

.table > center > table > tbody > .body > td > a > div > p {
    font-size: 30px;
    font-family: 'JR';
    color: inherit;
}

.table > center > table > tbody > .body > td > a > div > div {
    order: -1;
    width: 45px;
    height: 45px;
    margin-top: -35px;
}

svg {
    fill: currentColor;
    width: 100%;
    height: 100%;
}

.title {
    background-image: url("../assets/servicios-bg-personas-familias.png");
    padding: 200px 300px;
    color: #fff;
    background-position: center;
    background-repeat: no-repeat;
}
.title > span {
    font-family: "JLI";
    font-size: 40px;
}
.title > h1 {
    font-family: "JBD";
    font-size: 50px;
}
#contactForm {
    margin-top: -100px;
    font-family: "JR";
    background-color: #fff;
    padding: 40px;
    position: absolute;
    border-radius: 10px;
    width: 400px;
    -webkit-box-shadow: 10px 10px 26px 0px rgba(0, 0, 0, 0.07);
    -moz-box-shadow: 10px 10px 26px 0px rgba(0, 0, 0, 0.07);
    box-shadow: 10px 10px 26px 0px rgba(0, 0, 0, 0.07);
    font-weight: bolder;
    right: 100px;
}
#contactForm > label {
    color: #65b24a;
    font-size: 24px;
    line-height: 25px;
}
.info {
    padding: 100px 0px;
}
.info > h1 {
    font-family: "JBD";
    color: #65b24a;
    padding-left: 300px;
    font-size: 50px;
}
.info > p {
    font-family: "JR";
    width: 60%;
    padding-left: 300px;
    margin-top: 10px;
    font-size: 18px;
}
.service > h1 {
    margin-top: 20px;
    padding: 20px 200px 20px 200px;
    width: 100%;
    font-family: 'JBD';
    color: #2d4f98;
    font-size: 28px;
}
    .service > div {
        margin-top: -20px;
        width: 100%;
    }
    .service > div {
        width: 100%;
        display: flex;
    }
    .service > div > div > img {
        width: 350px;
        float: left;
    }
    .service > div > .imgbox {
        display: block;
        width: 350px;
        z-index: 99999;
    }
    .service > div > .box {
        margin-left: -300px;
        margin-top: 50px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 30px 30px 350px;
    }
    .service > div > .box > button {
        font-family: 'JR';
        background-color: #2d4f98;
        color: #fff;
        border-radius: 14px;
        padding: 7px 25px 7px 25px;
        border-style: none;
        font-weight: bolder;
        font-size: 18px;
    }
    .service > div > .box > img {
        width: 40px;
    }
    .service > div > .box > label {
        margin-left: 20px;
        color:#65b24a;
        font-size: 20px;
        font-family: 'JBD';
    }
    .service > div > .box > p {
        margin-bottom: 20px;
        font-family: 'JBD';
        margin-left: 60px;
    }
    .service > div > .box2 {
        margin-right: -300px;
        margin-top: 60px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 350px 100px 30px;
    }
    .service > div > .right{
        position: absolute;
        right: 15%;
    }
    .service > div > .box > h1 {
        position: relative;
        font-family: 'JBD';
        color:#2d4f98;
        margin-top: -120px;
        margin-bottom: 60px;
        text-align: left;
    }
    .service > div > .box > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .service > div > .box2 > h1 {
        position: relative;
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 10px;
        margin-top: -120px;
        text-align: right;
        margin-bottom: 60px;
    }
    .service > div > .box2 > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
.services {
    padding: 50px 300px;
    width: 100%;
}
.services > center {
    display: contents;
}
.services > center > div {
    display: inline-block;
    width: 100%;
}
.services > center > h1 {
    font-family: "JBD";
    color: #2d4f98;
    margin-bottom: 50px;
    font-size: 30px;
}
.services > center > div > div {
    display: inline-flex;
    width: 33.333333333%;
    float: left;
}
.services > center > div > div > .service {
    width: 100%;
}
.services > center > div > div > .service > div {
    position: relative;
    width: 100%;
    height: 100%;
    padding: auto;
    margin-bottom: 35px;
    transition: margin-top 0.5s ease-out 100ms;
}
.services > center > div > div > .service > div:hover {
    margin-top: -10px;
}
.services > center > div > div > .service > div > img {
    width: 100%;
    height: auto;
}
.services > center > div > div > .service > div > p {
    font-family: "JR";
    font-size: 18px;
}
.colectivo {
    background: -webkit-gradient(linear,left bottom,right top,color-stop(30%, #f7ebff),to(#cbe5fe));
    background: linear-gradient(to top right, #f7ebff 30%, #cbe5fe 100%);
}
.colectivo > center {
    padding: 50px 200px;
}
.colectivo > center > p {
    font-family: "JR";
    text-align: left;
    font-size: 22px;
    line-height: 25px;
}
.colectivo > center > div {
    display: flex;
}
.colectivo > center > div > .informacion {
    padding-top: 120px;
    text-align: left;
    padding-left: 50px;
}
.colectivo > center > div > .informacion > label {
    font-family: "JBD";
    color: #2d4f98;
    margin-bottom: 20px;
}
.colectivo > center > div > .informacion > h1 {
    font-family: "JBD";
    color: #2d4f98;
    margin-bottom: 20px;
}
.colectivo > center > div > .informacion > p {
    font-family: "JR";
    font-size: 22px;
    line-height: 25px;
    margin-bottom: 20px;
}
.colectivo > center > div > .informacion > button {
    font-family: "JR";
    background-color: #2d4f98;
    color: #fff;
    border-radius: 14px;
    padding: 7px 25px 7px 25px;
    border-style: none;
    font-weight: bolder;
    font-size: 18px;
    border-style: solid;
    border-color: #2d4f98;
}
.colectivo > center > div > .informacion > button:hover {
    background: #65b24a;
    color: #fff;
    border-color: #fff;
    border-style: solid;
}
.facirclecheck-service {
    margin-right: 4px;
    margin-top: 4px;
    font-weight: bolder;
    color: #2d4f98;
    width: 15px;
    height: 15px;
    float: left;
}
.plan > center {
    padding: 50px 200px;
}
.plan > center > div {
    display: flex;
}
.plan > center > div > div {
    padding-top: 30px;
    text-align: left;
}
.plan > center > div > img {
    width: auto;
    height: auto;
}
.plan > center > div > div > h1 {
    font-family: "JBD";
    color: #2d4f98;
}
.plan > center > div > div > p {
    font-family: "JR";
    font-size: 18px;
    line-height: 25px;
}
.connect {
    background: -prefix-linear-gradient(left, #2d4f98, #65b24a);
    background: linear-gradient(to right, #2d4f98 30%, #65b24a);
    height: 200px;
    width: 100%;
}

.connect > img {
    position: absolute;
    height: 200px;
    width: 380px;
    right: 0;
    object-fit: cover;
    object-position: 75px -70px;
}
.connect > h1 {
    font-family: "JBD";
    padding-top: 50px;
    padding-left: 200px;
    color: #65b24a;
}
.connect > p {
    font-family: "JR";
    padding-left: 200px;
    width: 80%;
    color: #fff;
    font-size: 22px;
    line-height: 25px;
}
.move > center > img {
    margin-top: 30px;
    width: 800px;
}
.vissible {
    display: none;
}
@media (max-width: 1500px) {
    .title {
        padding: 200px 200px;
    }
    .info > h1 {
        padding-left: 200px;
    }
    .info > p {
        padding-left: 200px;
    }
    .services {
        padding: 50px 200px;
        width: 100%;
    }
}
@media (max-width: 1400px) {
    .title {
        padding: 200px 100px;
    }
    .info > h1 {
        padding-left: 100px;
    }
    .info > p {
        padding-left: 100px;
    }
    .services {
        padding: 50px 100px;
        width: 100%;
    }
    .colectivo > center {
        padding: 50px 100px;
    }
    .plan > center {
        padding: 50px 100px;
    }
    .service {
            padding: 20px 150px;
            width: 100%;
        }
}
@media (max-width: 1300px) {
    .table {
        padding: 50px 150px;
    }
    .info > h1 {
        font-size: 30px;
    }
    .info > p {
        width: 50%;
    }
    .services {
        padding: 50px 50px;
        width: 100%;
    }
    .colectivo > center {
        padding: 50px 50px;
    }
    .plan > center {
        padding: 50px 50px;
    }
    .service {
        padding: 20px 75px;
        width: 100%;
    }
    .service > div > .right{
        position: absolute;
        right: 10%;
    }
}
@media (max-width: 1200px) {
    .table {
        padding: 50px 100px;
    }
    .plan > center > div {
        display: block;
    }
    .plan > center > div > img {
        width: 70%;
        height: auto;
    }
    }
    @media (max-width: 1100px) {
    .service {
        padding: 20px 50px;
        width: 100%;
    }
    .service > div > .right{
        position: absolute;
        right: 5%;
    }
    .table {
        padding: 50px 75px;
    }
    .connect > h1 {
        padding-top: 10px;
        padding-left: 100px;
        z-index: 99999999;
        position: sticky;
    }
    .connect > p {
        padding-left: 100px;
        z-index: 99999999;
        position: sticky;
    }
    #contactForm {
        margin-top: -100px;
        right: 50px;
    }
}
@media (max-width: 1000px) {
    .table {
        padding: 50px 50px;
    }
    .title {
        padding: 50px 0px;
        height: 400px;
        text-align: center;
    }
    #contactForm {
        margin-top: 10px;
        left: 0;
        right: 0;
        margin: auto;
    }
    .info {
        padding-top: 300px;
        width: 100%;
        text-align: center;
        padding-bottom: 0;
        text-align: center;
    }
    .info > h1 {
        padding: 20px;
        text-align: center;
        width: 100%;
    }
    .info > p {
        width: 100%;
        text-align: center;
        padding: 10px;
    }
    .services {
        padding: 0px 50px;
    }
    .connect > h1 {
        padding-left: 50px;
        font-size: 30px;
    }
    .connect > p {
        padding-left: 50px;
        font-size: 18px;
    }
}
@media (max-width: 900px) {
    .service > div {
        display: grid;
    }
    .service > h1 {
        padding: 20px 100px 20px 100px;
    }
    .service > div > .box{
        margin-left: 0px;
        margin-top: 0px;
        width: 100%;
        padding: 30px 30px 30px 30px;
    }

    .service > div > .box2 {
        margin-right: 0px;
        margin-top: 0px;
        background-color: #fff;
        width: 100%;
        padding: 30px 30px 100px 30px;
    }
    .service > div > .imgbox {
        display: block;
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .service > div > .imgbox > img{
        width: 250px;
        margin: auto;
    }
    .service > div > .right{
        position: relative;
        right: 0px;
    }
    .service > div > .box2 > h1 {
        margin-top: 0px;
        margin-bottom: 20px;
        text-align: left;
    }
    .service > div > .box > h1 {
        margin-top: 0px;
        margin-bottom: 20px;
        text-align: left;
    }
    .table {
        padding: 50px 25px;
    }
    .colectivo > center > div {
        display: block;
    }
    .move > center > img {
        width: 700px;
    }
}
@media (max-width: 800px) {
    .services > center > div > div {
        display: block;
        width: 60%;
        float: none;
    }
    .move > center > img {
        width: 600px;
    }
}
@media (max-width: 700px) {
    .colectivo > center > div > .informacion {
        padding-left: 0px;
        padding-top: 50px;
    }
    .colectivo > center > div > .informacion > h1 {
        font-size: 30px;
    }
    .plan > center > div > div > h1 {
        font-size: 30px;
    }
    .plan > center > div > div > p {
        font-size: 18px;
    }
    .plan > center > div > img {
        width: 95%;
        height: auto;
    }
    .move > center > img {
        width: 500px;
    }
    .service > h1 {
        padding: 20px 50px 20px 50px;
    }
}
@media (max-width: 600px) {
    .colectivo > center > div {
        display: block;
    }
    .colectivo > center > div > .img > img {
        width: 100%;
    }
    .colectivo > center > p {
        font-size: 18px;
    }
    .colectivo > center > div > .informacion > h1 {
        font-size: 25px;
    }
    .colectivo > center > div > .informacion > p {
        font-size: 18px;
    }
    .plan > center > div > div > h1 {
        font-size: 25px;
    }
    .plan > center > div > div > p {
        font-size: 18px;
    }
    .connect > h1 {
        font-size: 18px;
    }
    .connect > p {
        font-size: 18px;
        width: 100%;
    }
    .services > center > div > div {
        width: 70%;
    }
    .move > center > img {
        width: 400px;
    }
}
@media (max-width: 500px) {
    .service {
        padding: 20px 25px;
    }
    .service > h1 {
        padding: 20px 20px 20px 20px;
    }
    #contactForm {
        width: 300px;
    }
    .connect > h1 {
        padding-left: 25px;
    }
    .connect > p {
        padding-left: 25px;
    }
    .services > center > div > div {
        width: 80%;
    }
    .move > center > img {
        width: 300px;
    }
    .list > div {
        padding: 100px 0%;
    }
    .list {
        padding: 10px 0px;
    }
}
@media (max-width: 400px) {
    .services > center > div > div {
        width: 90%;
    }
    .move > center > img {
        width: 250px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/aliado.vue